export default __webpack_public_path__ + "static/media/manual1.eca9be1b.png";